import React from "react";
import { AuthLayout } from "@/components/layout/AuthLayout";
import { RegisterNewForm } from "@/components/auth/RegisterNewForm";

const RegisterNew = () => {
  return (
    <AuthLayout>
      <RegisterNewForm />
    </AuthLayout>
  );
};

export default RegisterNew;
